import Grid from "@afa-shared/afa-components/dist/Grid";
import AccordionDetails, { type AccordionItem } from "@components/Accordion";
import RichTextRenderer from "@components/RichTextRenderer";

import type { Context } from "types/context/Context";

import type { FAQType_faq } from "./queries/contentfulTypes/FAQType";

interface FaqBlockProps {
  blockData: FAQType_faq;
  uniqueKey?: string;
  context?: Context;
  filterInsuranceEvent?: string;
  filterSubject?: string;
}

export default function FAQBlock({
  blockData: faq,
  uniqueKey,
  context,
  filterInsuranceEvent,
  filterSubject,
}: FaqBlockProps) {
  // Build a single-item FAQ accordion. If you later have a list, map to AccordionItem[] instead.
  const items: AccordionItem[] = [
    {
      id: uniqueKey ?? undefined,
      question: faq?.question ?? "",
      answer: (
        <div className="accordionWrapper">
          {faq?.answer?.json && (
            <RichTextRenderer json={faq.answer.json} links={faq.answer.links} />
          )}
        </div>
      ),
    },
  ];

  return (
    <Grid data-blockname="faq">
      <AccordionDetails
        variant="faq"
        items={items}
        headingTag="h3"
        className="variant-faq"
        tracking={{
          event: "faq_click",
          insurance: filterInsuranceEvent || context?.insuranceName,
          sectionTitle:
            context?.accordionHeading ??
            context?.sectionBlock?.sectionBlockHeading ??
            context?.pageHeading,
          sectionIndex: context?.sectionBlockIndex ?? context?.sectionBlock?.sectionBlockIndex,
          subject: filterSubject,
        }}
      />
    </Grid>
  );
}
